
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { SidebarProvider } from './context/SidebarContext';
import './App.css';
import ScrollToTop from './pages/components/ScrollToTop';
// import AnimatedCursor from "react-animated-cursor"
import Login from './pages/components/Login';
import Home from './pages/web/home';
import UserList from './pages/components/UserList'
import Dashboard from './pages/Dashboard';
import NotFound from './pages/components/NotFound';
import UserDetail from './pages/components/UserDetail';
import Settings from './pages/Settings';
import Register from './pages/components/Register';
import Announcement from './pages/Announcement';
// import AdsSettings from './pages/components/AdsSettings';
import { Toaster } from 'react-hot-toast';
import WeeklyLeaderboard from './pages/components/Weekly-leaderboard';
import PioneerList from './pages/PioneerList';
import PioneerEmailEditor from './pages/components/PioneerEmailEditor';
import Notifications from './pages/notifications';
import UserNotifications from './pages/UserNotifications';
import UserChartPage from './pages/components/UserChartPage';
import ProfileVerificationsPage from './pages/ProfileVerifications';
import CreatorHub from './pages/CreatorHub';
import MileStone from './pages/MileStone';
import DeveloperCollaboration from './pages/DeveloperCollaboration';
import DuplicateAccount from './pages/DuplicateAccount';
import DuplicateAccountDetail from './pages/DuplicateAccountDetail';
import TodayUsers from './pages/TodayUsers';
import KYC from './pages/KYC';
import KYCUsers from './pages/KYCUsers';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import EventWinners from './pages/EventWinners';
import EventParticipants from './pages/EventParticipants';
import EventNotifications from './pages/EventNotifications';
import CoinHistory from './pages/CoinHistory';
import UserCoinHistoryPage from './pages/UserCoinHistoryPage';
import TapGame from './pages/TapGame';
import BoomCards from './pages/BoomCards';
import SlotsGame from './pages/SlotsGame';
import SpinWheelGame from './pages/SpinWheelGame';
import GamesManagement from './pages/GamesManagement';
import Game2048 from './pages/Game2048';
import FruitBombGame from './pages/FruitBombGame';
import TimerRewardGame from './pages/TimerRewardGame';
import EventPointsLedger from './pages/EventPointsLedger';



function App() {

  const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("token");
    return token ? children : <Navigate to="/home" />;
  };
  
  
  return (
    <SidebarProvider>
    <Toaster position="top-right" />
      <Router>
        <ScrollToTop />
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="/home" element={<Home />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/user" element={<ProtectedRoute><UserList /></ProtectedRoute>} />
            <Route path="/user/:id" element={<ProtectedRoute><UserDetail /></ProtectedRoute>} />
            <Route path="/user-full-details/:id" element={<ProtectedRoute><UserDetail /></ProtectedRoute>} />
            <Route path="/user/:id/coin-history" element={<ProtectedRoute><UserCoinHistoryPage /></ProtectedRoute>} />
            <Route path="/user-coin-history/:id" element={<ProtectedRoute><UserCoinHistoryPage /></ProtectedRoute>} />
            <Route path="/users/:id/coin-history" element={<ProtectedRoute><UserCoinHistoryPage /></ProtectedRoute>} />
            <Route path="/today-users" element={<ProtectedRoute><TodayUsers /></ProtectedRoute>} />
            <Route path="/today-registered-users" element={<ProtectedRoute><TodayUsers /></ProtectedRoute>} />
            <Route path="/coin-history" element={<ProtectedRoute><CoinHistory /></ProtectedRoute>} />
            <Route path="/users/coin-history" element={<ProtectedRoute><CoinHistory /></ProtectedRoute>} />
            <Route path="/events" element={<ProtectedRoute><Events /></ProtectedRoute>} />
            <Route path="/events/:id" element={<ProtectedRoute><EventDetail /></ProtectedRoute>} />
            <Route path="/events/:id/winners" element={<ProtectedRoute><EventWinners /></ProtectedRoute>} />
            <Route path="/events/winners" element={<ProtectedRoute><EventWinners /></ProtectedRoute>} />
            <Route path="/events/:id/participants" element={<ProtectedRoute><EventParticipants /></ProtectedRoute>} />
            <Route path="/events/notifications" element={<ProtectedRoute><EventNotifications /></ProtectedRoute>} />
            <Route path="/events/:id/notifications" element={<ProtectedRoute><EventNotifications /></ProtectedRoute>} />
            <Route path="/admin/event-notifications" element={<ProtectedRoute><EventNotifications /></ProtectedRoute>} />
            <Route path="/games" element={<ProtectedRoute><GamesManagement /></ProtectedRoute>} />
            <Route path="/game" element={<ProtectedRoute><GamesManagement /></ProtectedRoute>} />
            <Route path="/admin/games" element={<ProtectedRoute><GamesManagement /></ProtectedRoute>} />
            <Route path="/boom-cards" element={<ProtectedRoute><BoomCards /></ProtectedRoute>} />
            <Route path="/game/boomcards" element={<ProtectedRoute><BoomCards /></ProtectedRoute>} />
            <Route path="/tap-game" element={<ProtectedRoute><TapGame /></ProtectedRoute>} />
            <Route path="/game/tap" element={<ProtectedRoute><TapGame /></ProtectedRoute>} />
            <Route path="/slots-game" element={<ProtectedRoute><SlotsGame /></ProtectedRoute>} />
            <Route path="/game/slots" element={<ProtectedRoute><SlotsGame /></ProtectedRoute>} />
            <Route path="/slots" element={<ProtectedRoute><SlotsGame /></ProtectedRoute>} />
            <Route path="/spin-wheel" element={<ProtectedRoute><SpinWheelGame /></ProtectedRoute>} />
            <Route path="/game/spinwheel" element={<ProtectedRoute><SpinWheelGame /></ProtectedRoute>} />
            <Route path="/spinwheel" element={<ProtectedRoute><SpinWheelGame /></ProtectedRoute>} />
            <Route path="/game/2048" element={<ProtectedRoute><Game2048 /></ProtectedRoute>} />
            <Route path="/game-2048" element={<ProtectedRoute><Game2048 /></ProtectedRoute>} />
            <Route path="/game/fruit-bomb" element={<ProtectedRoute><FruitBombGame /></ProtectedRoute>} />
            <Route path="/game/fruit-Bomb" element={<ProtectedRoute><FruitBombGame /></ProtectedRoute>} />
            <Route path="/fruit-bomb" element={<ProtectedRoute><FruitBombGame /></ProtectedRoute>} />
            <Route path="/game/timer" element={<ProtectedRoute><TimerRewardGame /></ProtectedRoute>} />
            <Route path="/timer-game" element={<ProtectedRoute><TimerRewardGame /></ProtectedRoute>} />
            <Route path="/game/timer-reward" element={<ProtectedRoute><TimerRewardGame /></ProtectedRoute>} />
            <Route path="/game/event-points" element={<ProtectedRoute><EventPointsLedger /></ProtectedRoute>} />
            <Route path="/events/points-ledger" element={<ProtectedRoute><EventPointsLedger /></ProtectedRoute>} />
            <Route path="/game/history" element={<ProtectedRoute><GamesManagement /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/announcement" element={<ProtectedRoute><Announcement /></ProtectedRoute>} />
            <Route path="/weekly-leaderboard" element={<ProtectedRoute><WeeklyLeaderboard /></ProtectedRoute>} />
            <Route path="/pioneer-list" element={<ProtectedRoute><PioneerList /></ProtectedRoute>} />
            <Route path="/pioneer-email" element={<ProtectedRoute><PioneerEmailEditor /></ProtectedRoute>} />
            <Route path="/creator-hub" element={<ProtectedRoute><CreatorHub /></ProtectedRoute>} />
            <Route path="/milestone" element={<ProtectedRoute><MileStone /></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
            <Route path="/user-notifications" element={<ProtectedRoute><UserNotifications /></ProtectedRoute>} />
            <Route path="/push-notifications" element={<ProtectedRoute><UserNotifications /></ProtectedRoute>} />
            <Route path="/admin/user-notifications" element={<ProtectedRoute><UserNotifications /></ProtectedRoute>} />
            <Route path="/chart" element={<ProtectedRoute><UserChartPage /></ProtectedRoute>} />
            <Route path="/profile-verifications" element={<ProtectedRoute><ProfileVerificationsPage /></ProtectedRoute>} />
            <Route path="/developer-collaboration" element={<ProtectedRoute><DeveloperCollaboration /></ProtectedRoute>} />
            <Route path="/duplicate-account" element={<ProtectedRoute><DuplicateAccount /></ProtectedRoute>} />
            <Route path="/duplicate-account/:uuid" element={<ProtectedRoute><DuplicateAccountDetail /></ProtectedRoute>} />
            <Route path="/duplicate-users" element={<ProtectedRoute><DuplicateAccount /></ProtectedRoute>} />
            <Route path="/duplicate-users/:uuid" element={<ProtectedRoute><DuplicateAccountDetail /></ProtectedRoute>} />
            <Route path="/kyc" element={<ProtectedRoute><KYC /></ProtectedRoute>} />
            <Route path="/kyc-users" element={<ProtectedRoute><KYCUsers /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
            {/* <Route path="/ads-settings" element={<AdsSettings />} /> */}
        </Routes>
      </Router>

    {/* <AnimatedCursor
      innerSize={10}
      outerSize={20}
      color='70, 70, 229'
      outerAlpha={0.2}
      innerScale={1}
      outerScale={5}
    /> */}
    </SidebarProvider>
  );
}

export default App;
